import { pluralize } from 'src/lib/format';

export const STRUCTURE_INSTRUCTIONS_LABEL = 'Structure, Format, and Vocabulary';
export const STRUCTURE_INSTRUCTIONS_SUBLABEL =
  'Choose from the available options, or type custom formatting instructions here';
export const STRUCTURE_INSTRUCTIONS_LABEL_WITH_CASCADE_WARNING =
  'Structure, Format, and Vocabulary (will be applied to all assets)';

export const AI_CHAT_LABEL = 'Content Agent';
export const CONTENT_IMPROVER_LABEL = 'Content Improver';

export const prepareKeywordHint = ({
  maxKeywords,
  maxWordsPerKeyword,
  disabled,
  disabledKeywordsHint,
}: {
  maxKeywords: number;
  maxWordsPerKeyword: number;
  disabled: boolean;
  disabledKeywordsHint: string;
}) => {
  if (disabled) {
    return disabledKeywordsHint;
  }

  if (maxWordsPerKeyword === 1) {
    return 'Include a 1-word talking point.';
  }

  const postfix = pluralize(maxWordsPerKeyword, 'word', 'words');
  if (maxKeywords === 1) {
    return `Include a talking point. It can be up to ${maxWordsPerKeyword} ${postfix}.`;
  }
  return `Add up to ${maxKeywords} talking points.\nEach talking point can be up to ${maxWordsPerKeyword} ${postfix} long.`;
};
